// extracted by mini-css-extract-plugin
export default {"appContainer":"App_appContainer__Q73Qs","loading":"App_loading__Z10nZ","spinner":"App_spinner__h+vrd","spin":"App_spin__RBUaI","loadingText":"App_loadingText__qJ1ef"};